import React from 'react';
import { GenerateIcon, ICONS } from '@pileus-cloud/anodot-frontend-common';
import useTokens from 'users/new-user-management/hooks/reactQuery/useTokens';
import Tooltip from 'shared/components/andtComponents/Tooltip';
import { Routes } from 'shared/constants/routes';
import Button from 'shared/components/andtComponents/Button';
import { useRootStore } from 'app/contexts/RootStoreContext';
import toast from 'shared/components/andtComponents/Toast';
import { useNavigate } from 'react-router';
import styles from './UserImpersonate.module.scss';
import tooltipStyles from 'shared/components/andtComponents/Tooltip.module.scss';
import { ReactComponent as ImpersonateSessionIcon } from 'shared/img/icons/impersonate-session.svg';

const UserImpersonate = ({ row }) => {
  const { id, impersonatable = false, enabled } = row;
  const { useExchangeTokenByUserImpersonationToken } = useTokens();
  const { usersStore } = useRootStore();
  const { mutate: exchangeTokenByUserImpersonationToken, isLoading } = useExchangeTokenByUserImpersonationToken({
    handleOnSuccess: onImpersonateSuccess,
  });
  const navigate = useNavigate();

  async function onImpersonateSuccess({ accessToken }) {
    if (!accessToken) {
      toast.error('Failed to impersonate user');
      return;
    }
    await usersStore.impersonateUser({ token: accessToken, userId: id });
    navigate(Routes.LANDING);
  }

  const impersonateUser = async (e) => {
    e.stopPropagation();
    if (isLoading) {
      return;
    }
    exchangeTokenByUserImpersonationToken({ userId: id });
  };

  const getImpersonateTooltipText = () => {
    return (
      <div className={styles.impersonateTooltip}>
        <h3>Impersonate</h3>
        <p>
          An impersonation session is limited to <span>60 minutes</span>. You will be logged out of the platform when
          the time is up.
        </p>
        <ImpersonateSessionIcon />
      </div>
    );
  };

  if (usersStore?.authUserKey !== id && !!impersonatable) {
    return (
      <Tooltip
        title={getImpersonateTooltipText()}
        placement="left"
        classes={{ tooltip: tooltipStyles.whiteTooltip, arrow: tooltipStyles.whiteArrow }}
      >
        <span>
          <Button
            onClick={impersonateUser}
            isTextButton
            isLoading={isLoading}
            disabled={!enabled}
            overrideStyles={{ padding: 0 }}
            icon={<GenerateIcon iconName={ICONS.userSecret.name} className={styles.impersonateIcon} />}
          />
        </span>
      </Tooltip>
    );
  }

  return null;
};


export default UserImpersonate;
